module.exports = __webpack_public_path__ + "img/TS_ICON_NATURE.3aa718f0.png";